// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.delete-product-container {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    background-color: black;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  
  .delete-product-container h2 {
    text-align: center;
    color: white;
  }
  
  .category-selector {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
    color: white;
  }
  
  .category-selector label {
    margin-right: 10px;
  }
  
  select {
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
  }
  
  .status-message {
    text-align: center;
    font-size: 1rem;
    color: green;
    margin-bottom: 20px;
  }
  
  .product-list {
    list-style-type: none;
    padding: 0;
  }
  
  .product-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid #ddd;
  }
  
  .product-details {
    flex-grow: 1;
  }
  
  .delete-product-container h3 {
    margin: 0;
    font-size: 1.2rem;
    color: white;
  }
  
  .delete-product-container p {
    margin: 5px 0;
    color: gray;
  }
  
  .delete-button {
    background-color: #dc3545;
    color: white;
    border: none;
    padding: 8px 12px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 1rem;
  }
  
  .delete-button:hover {
    background-color: #c82333;
  }
  `, "",{"version":3,"sources":["webpack://./src/private/Admin/DeleteProduct.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,wCAAwC;EAC1C;;EAEA;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,6BAA6B;EAC/B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,SAAS;IACT,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B","sourcesContent":[".delete-product-container {\r\n    max-width: 800px;\r\n    margin: 0 auto;\r\n    padding: 20px;\r\n    background-color: black;\r\n    border-radius: 8px;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n  }\r\n  \r\n  .delete-product-container h2 {\r\n    text-align: center;\r\n    color: white;\r\n  }\r\n  \r\n  .category-selector {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    margin-bottom: 20px;\r\n    color: white;\r\n  }\r\n  \r\n  .category-selector label {\r\n    margin-right: 10px;\r\n  }\r\n  \r\n  select {\r\n    padding: 8px;\r\n    border: 1px solid #ddd;\r\n    border-radius: 4px;\r\n  }\r\n  \r\n  .status-message {\r\n    text-align: center;\r\n    font-size: 1rem;\r\n    color: green;\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  .product-list {\r\n    list-style-type: none;\r\n    padding: 0;\r\n  }\r\n  \r\n  .product-item {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 10px 0;\r\n    border-bottom: 1px solid #ddd;\r\n  }\r\n  \r\n  .product-details {\r\n    flex-grow: 1;\r\n  }\r\n  \r\n  .delete-product-container h3 {\r\n    margin: 0;\r\n    font-size: 1.2rem;\r\n    color: white;\r\n  }\r\n  \r\n  .delete-product-container p {\r\n    margin: 5px 0;\r\n    color: gray;\r\n  }\r\n  \r\n  .delete-button {\r\n    background-color: #dc3545;\r\n    color: white;\r\n    border: none;\r\n    padding: 8px 12px;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    font-size: 1rem;\r\n  }\r\n  \r\n  .delete-button:hover {\r\n    background-color: #c82333;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
